const STORAGE_KEY = 'byte_search_history';
const MAX_ENTRIES = 10;

export interface SearchHistoryEntry {
  query: string;
  type: string;
  route: string;
  label: string;
  timestamp: number;
}

export function getSearchHistory(): SearchHistoryEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addSearchHistory(entry: Omit<SearchHistoryEntry, 'timestamp'>): void {
  const history = getSearchHistory();
  // Remove duplicate if same route exists
  const filtered = history.filter((h) => h.route !== entry.route);
  const newEntry: SearchHistoryEntry = { ...entry, timestamp: Date.now() };
  const updated = [newEntry, ...filtered].slice(0, MAX_ENTRIES);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

export function clearSearchHistory(): void {
  localStorage.removeItem(STORAGE_KEY);
}
